import {useEffect, useState} from 'react'
import actions from 'redux-auto'
import Api from '#services/api'

export const useSharedFileUrl = (blobId, userId) => {
  const [sharedFileUrl, setSharedFileUrl] = useState({
    url: undefined,
    isLoading: true,
    notFound: false,
  })
  useEffect(() => {
    const getSharedFileUrl = async () => {
      try {
        const sharedFile = await Api.getUserFileUrl(blobId, userId)
        setSharedFileUrl({
          url: sharedFile.url,
          isLoading: false,
          notFound: false,
        })
      } catch (e) {
        if (e.status === 404) {
          setSharedFileUrl({isLoading: false, notFound: true, url: undefined})
        } else {
          actions.error.writeError({error: e})
          setSharedFileUrl({isLoading: false, notFound: false, url: undefined})
        }
      }
    }
    getSharedFileUrl()
  }, [blobId, userId])
  return sharedFileUrl
}
